 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"activityReports~articles~awards~contacts~createUser~editPages~editUser~patientStory~popupBanners~pub~7f0d783a":"activityReports~articles~awards~contacts~createUser~editPages~editUser~patientStory~popupBanners~pub~7f0d783a","activityReports~articles~awards~contacts~patientStory~popupBanners~publications~users":"activityReports~articles~awards~contacts~patientStory~popupBanners~publications~users","activityReports":"activityReports","articles":"articles","awards":"awards","contacts":"contacts","patientStory":"patientStory","popupBanners":"popupBanners","publications":"publications","users":"users","createUser":"createUser","editArticle~editAward~editPages~editPatientStory":"editArticle~editAward~editPages~editPatientStory","editPages":"editPages","editUser":"editUser","createPopupBanner~editPopupBanner":"createPopupBanner~editPopupBanner","createPopupBanner":"createPopupBanner","editPopupBanner":"editPopupBanner","editActivityReports":"editActivityReports","editArticle~uploadImages":"editArticle~uploadImages","editArticle":"editArticle","editAward":"editAward","editPatientStory":"editPatientStory","uploadImages":"uploadImages","editContact":"editContact","editPublications":"editPublications","files":"files","images":"images","metatags":"metatags","pages":"pages","profile":"profile","text":"text"}[chunkId]||chunkId) + "." + {"activityReports~articles~awards~contacts~createUser~editPages~editUser~patientStory~popupBanners~pub~7f0d783a":"094b7588","activityReports~articles~awards~contacts~patientStory~popupBanners~publications~users":"d9b88841","activityReports":"a5b405e6","articles":"e461b204","awards":"2f141a54","contacts":"6130c1b1","patientStory":"f377187c","popupBanners":"24598d72","publications":"f3b77402","users":"d733813f","createUser":"d472353a","editArticle~editAward~editPages~editPatientStory":"207b0a93","editPages":"23b1684d","editUser":"465a76a9","createPopupBanner~editPopupBanner":"1781a7a0","createPopupBanner":"39b83578","editPopupBanner":"d8ad43be","editActivityReports":"93e1b9a2","editArticle~uploadImages":"a8ca7eb1","editArticle":"d391b0d6","editAward":"e14e5605","editPatientStory":"bd3a2c54","uploadImages":"f0e419cd","editContact":"7df94ec1","editPublications":"d0834a3a","files":"857002b4","images":"9d2509a9","metatags":"c376d0fd","pages":"f61dcdae","profile":"cc04c68d","text":"45e85f52"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"activityReports~articles~awards~contacts~createUser~editPages~editUser~patientStory~popupBanners~pub~7f0d783a":1,"activityReports~articles~awards~contacts~patientStory~popupBanners~publications~users":1,"patientStory":1,"editArticle~editAward~editPages~editPatientStory":1,"editPages":1,"createPopupBanner~editPopupBanner":1,"editActivityReports":1,"editArticle~uploadImages":1,"editArticle":1,"editPatientStory":1,"uploadImages":1,"editContact":1,"editPublications":1,"files":1,"images":1,"metatags":1,"pages":1,"text":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"activityReports~articles~awards~contacts~createUser~editPages~editUser~patientStory~popupBanners~pub~7f0d783a":"activityReports~articles~awards~contacts~createUser~editPages~editUser~patientStory~popupBanners~pub~7f0d783a","activityReports~articles~awards~contacts~patientStory~popupBanners~publications~users":"activityReports~articles~awards~contacts~patientStory~popupBanners~publications~users","activityReports":"activityReports","articles":"articles","awards":"awards","contacts":"contacts","patientStory":"patientStory","popupBanners":"popupBanners","publications":"publications","users":"users","createUser":"createUser","editArticle~editAward~editPages~editPatientStory":"editArticle~editAward~editPages~editPatientStory","editPages":"editPages","editUser":"editUser","createPopupBanner~editPopupBanner":"createPopupBanner~editPopupBanner","createPopupBanner":"createPopupBanner","editPopupBanner":"editPopupBanner","editActivityReports":"editActivityReports","editArticle~uploadImages":"editArticle~uploadImages","editArticle":"editArticle","editAward":"editAward","editPatientStory":"editPatientStory","uploadImages":"uploadImages","editContact":"editContact","editPublications":"editPublications","files":"files","images":"images","metatags":"metatags","pages":"pages","profile":"profile","text":"text"}[chunkId]||chunkId) + "." + {"activityReports~articles~awards~contacts~createUser~editPages~editUser~patientStory~popupBanners~pub~7f0d783a":"a3de2a7f","activityReports~articles~awards~contacts~patientStory~popupBanners~publications~users":"ec2557d9","activityReports":"31d6cfe0","articles":"31d6cfe0","awards":"31d6cfe0","contacts":"31d6cfe0","patientStory":"f921b4fd","popupBanners":"31d6cfe0","publications":"31d6cfe0","users":"31d6cfe0","createUser":"31d6cfe0","editArticle~editAward~editPages~editPatientStory":"171a9665","editPages":"3f169f9e","editUser":"31d6cfe0","createPopupBanner~editPopupBanner":"3b98cd1c","createPopupBanner":"31d6cfe0","editPopupBanner":"31d6cfe0","editActivityReports":"b45a5d32","editArticle~uploadImages":"e5cc8114","editArticle":"82f85aa7","editAward":"31d6cfe0","editPatientStory":"fcfc477b","uploadImages":"0468a6bd","editContact":"712b5995","editPublications":"5ae0f071","files":"beb40510","images":"77714ee2","metatags":"53fc01d0","pages":"ac2d4641","profile":"31d6cfe0","text":"b103dcbd"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
